module.exports = __webpack_public_path__ + "static/media/CompetitiorAdd.e75124ee.docx";